// extracted by mini-css-extract-plugin
export default {"card-wrapper":"card-wrapper--TbINZ","heading":"heading--OczVs","button":"button--hnTYJ","max-width":"max-width--ve6jl","half-width":"half-width--D8XWN"};